import {
  HorizontalBar
} from "vue-chartjs";

export default {
  name: "HorizontalBar",
  extends: HorizontalBar,
  props: [
    //? Dados de configuração (chartBarData.datasets)
    "data",
    //? Dados dos textos Verticais (abaixo do gráfico)
    "labels",
    //? Opções de configuração (options) - options: {
    //?                                      width: "320px",
    //?                                      height: "300px",
    //?                                    },
    "modifyOptions",
  ],
  data: () => ({
    chartBarData: {
      labels: [],
      datasets: [],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: false,
        position: "top",
        text: "Some title"
      },
      tooltips: {
        mode: "index",
        intersect: false,
      },
      hover: {
        mode: "nearest",
        intersect: true,
      },
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: false,
            labelString: "Horizontal label"
          },
        }],
        yAxes: [{
          display: true,
          scaleLabel: {
            display: false,
            labelString: "Vertical label"
          }
        }]
      }
    },
  }),
  mounted() {
    if (this.modifyOptions) {
      this.formatChartBarOptions();
    }

    this.formatChartBarData();
  },
  watch: {
    data() {
      this.formatChartBarData();
      this.renderChart(this.chartBarData, this.options);
    },
    labels(val) {
      this.chartBarData.labels = val;
      this.renderChart(this.chartBarData, this.options);
    },
    modifyOptions() {
      this.formatChartBarOptions();
      this.renderChart(this.chartBarData, this.options);
    },
  },
  methods: {
    formatChartBarData() {
      // backgroundColor - cor da barra no gráfico
      // backgroundColorVariant - cor da barra de acordo com o valor sendo positivo ou negativo
      this.chartBarData.datasets = JSON.parse(JSON.stringify(this.data))
        .map((data) => {
          return {
            ...data,
            ...(
              data.backgroundColorVariant &&
                data.backgroundColorVariant[0] === data.label ? 
              {
                backgroundColor: data.data
                  .map((value) => value > 0 ?
                    data.backgroundColorVariant[1] :
                    data.backgroundColorVariant[2]
                  )
              } :
              {
                backgroundColor: data.backgroundColor,
              }
            ),
          }
        });
    },

    formatChartBarOptions() {
      //? Estrutura da prop "modifyOptions"
      //* options: {
      //*   width: "320px",
      //*   height: "300px",
      //*   title: {
      //*     display: true,
      //*     position: 'top',
      //*     text: 'Some title'
      //*   }
      //*   horizontalLabel: "Horizontal label",
      //*   verticalLabel: "Vertical label",
      //*   anyStyle: {
      //*     name: "margin-right",
      //*     value: "10px",
      //*   },
      //* },

      //? "document.getElementById("horizontalbar-chart").style"
      //? Com o código acima é possível alterar qualquer estilo do canvas
      //? Dê um console.log para vizualizar como o nome do estilo é configurado
      const {
        width,
        height,
        title,
        horizontalLabel,
        verticalLabel,
        anyStyle,
      } = this.modifyOptions;

      if (width) {
        this.options.responsive = false;

        const canvas = document.getElementById("horizontalbar-chart");
        canvas.style.width = width;

        // const listCanvas = document.getElementsByTagName("canvas");
        // for (var i = 0; i < listCanvas.length; i++) {
        //   listCanvas[i].style.width = width;
        // }
      }
      if (height) {
        const canvas = document.getElementById("horizontalbar-chart");
        canvas.style.height = height;
      }

      if (title) {
        this.options.title = {
          ...this.options.title,
          display: true,
          ...title, // { position: "top", text: "Some text" }
        };
      }

      if (horizontalLabel || verticalLabel) {
        if (horizontalLabel) {
          this.options.scales.xAxes[0].scaleLabel = {
            display: true,
            labelString: horizontalLabel,
          };
        }
        if (verticalLabel) {
          this.options.scales.yAxes[0].scaleLabel = {
            display: true,
            labelString: verticalLabel,
          };
        }
      }

      if (anyStyle) {
        document.getElementById("horizontalbar-chart")
          .style[anyStyle.name] = anyStyle.value;
      }
    },
  },
};